import React from "react";
import ReactDOM from "react-dom/client";
import elementService from "../../../js/common/ElementService";
import ProductDetailPageTypeConfig, { ProductDetailInfo } from "./ProductDetailPageTypeConfig";
import ProductErrorReportModal from "./components/ProductErrorReportModal";
import productDetailInfoService from "./ProductDetailInfoService";

export default new class ErrorReportFormService {
    public init(pageTypeConfig: ProductDetailPageTypeConfig): void {
        if (pageTypeConfig.detailType !== "multi") {
            return;
        }

        this.initErrorReportButtons(pageTypeConfig);
    }

    private initErrorReportButtons(pageTypeConfig: ProductDetailPageTypeConfig): void {
        for (const errorReportContainer of document.querySelectorAll<HTMLDivElement>(".js-product-error-report-container")) {
            ReactDOM.createRoot(errorReportContainer)
                .render(<ProductErrorReportModal
                    productDetailInfo={this.getProductDetailInfo(pageTypeConfig, errorReportContainer)}
                />);
        }
    }

    private getProductDetailInfo(pageTypeConfig: ProductDetailPageTypeConfig, errorReportContainer: HTMLDivElement): ProductDetailInfo {
        return productDetailInfoService.getProductDetailInfo(
            pageTypeConfig,
            Number.parseInt(elementService.elementData(errorReportContainer, "productId")),
        );
    }
}();
